<div class="modal-header">
  <h4 id="modal-label-3" class="modal-title">Offres</h4>
  <!-- <button aria-hidden="true" data-dismiss="modal" class="close" type="button">×</button> -->
</div>
<div class="modal-body">
  <div class="row">
    <!-- <div class="col-12">
        <p>filtres</p>

    </div> -->
    <div class="col-12 col-lg-6">
      <div class="showOffres d-sm-none" *ngIf="!offresVisible">
        <button class="btn btn-sm" (click)="toggleOffres()">
          Voir les Offres
        </button>
      </div>
      <div class="offres d-sm-block" [class.d-none]="!offresVisible">
        <div
          class="offre row"
          [class.selected]="offre.id == currentItem.id"
          [class.hasFirstClick]="hasFirstClick"
          *ngFor="let offre of offres"
        >
          <div
            class="tumbnail col-4 p-0"
            *ngIf="offre.imagePrincipale"
            [style.background-image]="
              getAsBackground(
                offre.imagePrincipale.id + '/' + offre.imagePrincipale.title
              )
            "
          ></div>
          <div class="col-8">
            <div class="title">
              {{ offre.title }}
            </div>
            <div class="actions">
              <button
                class="btn btn-sm"
                (click)="
                  setCurrentItem(offre);
                  hasFirstClick = true;
                  offresVisible = false
                "
              >
                Voir <i class="fas fa-eye"></i>
              </button>
              <!-- <button class="btn btn-sm" (click)="selectItem(offre)">Choisir</button> -->
              <button
                class="btn btn-sm"
                (click)="selectItem(offre)"
                *ngIf="!isSelectedItem(offre)"
              >
                Choisir <i class="fas fa-plus"></i>
              </button>
              <button
                class="btn btn-success btn-sm"
                (click)="unselectItem(offre)"
                *ngIf="isSelectedItem(offre)"
              >
                Choisi <i class="fa fa-check"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="col-12 col-lg-6 d-sm-block"
      [class.d-none]="offresVisible"
      *ngIf="currentItem"
    >
      <div class="row">
        <div class="col-12 ">
          <!-- Inspiro Slider -->
          <div
            id="slider"
            class="inspiro-slider dots-creative"
            *ngIf="currentItem"
          >
            <!-- Slide 1 -->
            <div
              *ngFor="let media of currentItem.medias"
              class="slide kenburns"
              [style.background-image]="
                getAsBackground(media.id + '/' + media.title)
              "
            >
              <!-- <div class="bg-overlay"></div> -->
              <!-- <button 
              [attr.title]="media.title ? media.title : 'noname'"
              data-lightbox="gallery-image"
              [href]="
                uploadedFilesUrl +
                (media.id
                  ? media.id + '/' + media.title
                  : selectedValue + '/noname')
              "
              class="btn btn-light btn-roundeded"
              >Voir en grand<i class="fas fa-expand"></i></button
            > -->
              <div class="container-fluid">
                <div class="slide-captions text-center text-light">
                  <!-- Captions -->
                  <!-- <span class="strong">WITH POLO TEMPLATE</span> -->
                  <!-- <h2 class="text-dark">{{ currentItem.title }}</h2>
                        <a class="btn btn-primary" href="#">Purchase Now</a>
                        <a class="btn btn-light">Purchase</a> -->
                  <!-- end: Captions -->
                </div>
              </div>
            </div>
            <!-- end: Slide 1 -->
          </div>
        </div>
        <div class="col-12 ">
            <div class="row">
                <div class="col-12">
                
                    <div  *ngIf="false"
                      class="carousel"
                      data-items="2"
                      data-dots="true"
                      data-lightbox="gallery"
                    >
                      <!-- portfolio item -->
                      <div
                        class="portfolio-item img-zoom ct-photography ct-media ct-branding ct-Media"
                        *ngFor="let media of currentItem.medias"
                      >
                        <div class="portfolio-item-wrap">
                          <div class="portfolio-image">
                            <img
                              [attr.src]="
                                uploadedFilesUrl +
                                (media.id
                                  ? media.id + '/' + media.title
                                  : selectedValue + '/noname')
                              "
                            />
                          </div>
                          <div class="portfolio-description">
                            <a
                              [attr.title]="media.title ? media.title : 'noname'"
                              data-lightbox="gallery-image"
                              [href]="
                                uploadedFilesUrl +
                                (media.id
                                  ? media.id + '/' + media.title
                                  : selectedValue + '/noname')
                              "
                              class="btn btn-light btn-roundeded"
                              >Voir en grand<i class="fas fa-expand"></i></a
                            >
                          </div>
                        </div>
                      </div>
                      <!-- <div style="width: 50px;">
                <br/>
                
                <button class="btn btn-sm" (click)="clear(media)">delete <i class="fa fa-times"></i></button>
              </div> -->
                      <!-- end: portfolio item -->
                    </div>
                </div>
                <div class="col-12">
                  <div class="room">
                    <!-- <div class="room-image" 
                    >
                        <div class="room-title">{{ item.title }}</div>
                    </div> -->
                    <div class="room-details">
                      <h4>{{ currentItem.title }}</h4>
                      <p>{{ currentItem.smallDescription }}</p>
        
                      <!-- <p>
                    <span class="badge bg-primary">{{ currentItem.type }}</span>
                    <span class="badge bg-primary"
                      >surface: {{ currentItem.superficie }} m²</span
                    >
                    <span class="badge bg-primary"
                      >pieces: {{ currentItem.pieces }}</span
                    >
                    <span class="badge bg-primary">ville: {{ currentItem.ville }}</span>
                  </p> -->
                      <div class="float-left">
                        <h5>{{ currentItem.loyer }} € <small>/ Mois</small></h5>
                      </div>
                      <div class="float-right">
                        <button
                          class="btn"
                          (click)="selectItem(currentItem)"
                          *ngIf="!isSelectedItem(currentItem)"
                        >
                          Choisir
                        </button>
                        <button
                          class="btn btn-success"
                          (click)="unselectItem(currentItem)"
                          *ngIf="isSelectedItem(currentItem)"
                        >
                          Choisi <i class="fa fa-check"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
      <!--end: Inspiro Slider -->
      <!-- <div class="rooms carousel" data-items="2" data-margin="20" data-dots="false">
            <div class="room" *ngFor="let item of offres">
        
                 <div class="room-image" 
                >
                    <div class="room-title">{{ item.title }}</div>
                </div>
                <div class="room-details">
                    <p>{{ item.title }}</p>
                    <p>{{ item.smallDescription}}</p>
                    
                    <p><span class="badge bg-primary">{{ item.type}}</span>
                        <span class="badge bg-primary">surface: {{ item.superficie}} m²</span>
                        <span class="badge bg-primary">pieces: {{ item.pieces}}</span>
                        <span class="badge bg-primary">ville: {{ item.ville}}</span>
                    </p>
                    <div class="float-left">
                        <h4>{{ item.loyer}}€ <small>/ Mois</small></h4>
                    </div>
                    <div class="float-right">
                        <button class="btn" (click)="selectItem(item)" *ngIf="!isSelectedItem(item)">Choisir</button>
                        <button class="btn btn-success" (click)="unselectItem(item)" *ngIf="isSelectedItem(item)">Choisi <i class="fa fa-check"></i></button>
                      
                    </div>
                </div>
            </div>
        </div> -->
    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-b" type="button" (click)="close()">
    retour au formulaire
  </button>
</div>

<!-- <div
class="modal fade show d-block"
id="modalInscription"
*ngIf="galleryVisible"
>
<div class="bg-overlay"></div>
<div class="modal-dialog modal-lg">
  <div class="modal-content">
    <app-cllajoffres (onClose)="toggleOffres()"></app-cllajoffres>
  </div>
</div>
</div> -->
